<template lang="pug">
  .contact.has-text-left
    .contact-questions
      h2.title.is-block-desktop-only.is-hidden-mobile CONTACT US
      h3
        | Couldn't find what you're looking for in our
        a(href="http://help.cybersmart.co.za", target="_blank")  help bot
        | ? We're here to help
      template(v-for="(v, k) of inputs")
        div.input-group(v-if="isEmpty(v['Conditional Field']) || formResults[v['Conditional Field']['Input Name']] == v['Conditional Value']")
          b(v-if="v['Option Text'] && v['Input Type'] !== 'checkbox'") {{v['Option Text']}}:
          search(@selected="setAddress" style="margin-top: .75rem" v-if="v['Input Name'] === 'fault-location-of-service'")
          v-select(v-else-if="v['Input Type'] === 'select'", :options="v.options", v-model="formResults[v['Input Name']]",
            :clearable="false" :searchable="false" :placeholder="v.Placeholder")
          .control.radio-control(v-else-if="v['Input Type'] === 'radio'")
            label.radio(v-for="(o, i) of v.options", :key="i")
              input(type="radio", :name="v['Input Name']", :value="o", :required="!!v.Required", v-model="formResults[v['Input Name']]", :checked="o === v['Default Value']")
              span.radio-checkmark
              | {{o}}
          hr.has-background-black(v-else-if="v['Input Type'] === 'bar'")
          .control(v-else-if="v['Input Type'] === 'checkbox'")
            label.radio
              input(type="checkbox", :name="v['Input Name']")
              span.radio-checkmark
              b {{v['Option Text']}}
          CustomTextArea(v-model="formResults[v['Input Name']]", :placeholder="v.Placeholder||''", :name="v['Input Name']", :value="v['Default Value']", :required="!!v.Required", v-else-if="v['Input Type'] === 'textarea'")
          CustomInput(v-model="formResults[v['Input Name']]", :placeholder="v.Placeholder||''", :name="v['Input Name']", :value="v['Default Value']", :required="!!v.Required", v-else)
          p.help.is-danger(v-if="errors[v['Input Name']]") {{ errors[v['Input Name']] }}
      p.is-red(v-if="contactResponse") {{ contactResponse }}
      button.button.is-primary.contact-button.is-block-mobile.is-inline-block-desktop(type="submit", @click="recaptcha") SUBMIT
    hr.is-block-tablet.is-hidden-desktop
    .contact-contact-us
      .contact-contact-box
        div.opening-hours-wrapper
          h2.title BUSINESS HOURS
          p
          | Monday To Friday:
          span(style="font-weight:normal")  8:00 AM to 8:00 PM
          li
            | Call Support:
            span(style="font-weight:normal")  8:00 AM to 1:00 PM
          li
            | WhatsApp Support:
            span(style="font-weight:normal")  8:00 AM to 8:00 PM
          br
          p
          | Saturday, Sunday:
          span(style="font-weight:normal")  8:00 AM to 5:00 PM
          li
            | Call Support:
            span(style="font-weight:normal")  Unavailable
          li
            | WhatsApp Support & E-mail Support:
            span(style="font-weight:normal")  8:00 AM to 5:00 PM
          br
        h2.title HELP DESK
        h3(style="font-weight:bold") TELEPHONE
        span(style="font-weight:normal")
          | Need assistance? Call us on 
          a.has-text-primary(href="tel:0212860123")  021 286 0123
        h3(style="font-weight:bold")
        span.contact-whatsapp
          | Or via WhatsApp 
          fa-icon(:icon="['fab', 'whatsapp-square']", size="2x", style="margin-right:5px;")
          a.has-text-primary(href="whatsapp://send?phone=+27640329224")  064 032 9224
          
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import CustomInput from "@/components/CustomInput.vue";
import CustomTextArea from "@/components/CustomTextArea.vue";
import { VueReCaptcha } from "vue-recaptcha-v3";
import Search from "@/components/Search.vue";

// For more options see below
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY });

export default {
  components: {
    CustomInput,
    CustomTextArea,
    Search,
  },
  data() {
    return {
      numRegex: /^\d+$/,
      // eslint-disable-next-line
      emailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      types: ["Fault Reporting", "stuff"],
      inputs: [],
      formResults: {},
      errors: {},
      contactResponse: "",
    };
  },
  async mounted() {
    this.inputs = _.orderBy(
      _.map(
        (
          await this.$http.get(
            `${process.env.VUE_APP_BACKEND_URL}contactformfields`
          )
        ).data,
        (v) => ({
          ...v,
          options: _.map(
            v["Input Options"]?.split(/\s*(?:\\\\,|(?=[^\\]),)\s*/g),
            (g) => g.trim()
          ),
        })
      ),
      ["Priority", "id"]
    );

    _.forEach(this.inputs, (v) => {
      Vue.set(this.formResults, [v["Input Name"]], v["Default Value"]);
    });
  },
  methods: {
    isEmpty: _.isEmpty,
    setAddress(newAddress) {
      this.formResults['fault-location-of-service'] = newAddress.description
    },
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded();

      // Execute reCAPTCHA with action "submit".
      const token = await this.$recaptcha("submit");

      // Do stuff with the received token.
      this.submit(token);
    },
    async submit(recaptchaToken) {
      // Check for required
      this.errors = {};
      const formData = new FormData();
      formData.append("recaptcha_token", recaptchaToken);

      /* eslint-disable */
      for (const key in this.formResults) {
        const input = _.find(this.inputs, (o) => {
          return o["Input Name"] === key;
        });
        if (
          input.Required &&
          (!input["Conditional Field"] ||
            this.formResults[input["Conditional Field"]["Input Name"]] ==
              input["Conditional Value"]) &&
          _.isEmpty(this.formResults[key])
        ) {
          this.errors[key] = `Missing ${input["Option Text"]}`;
        } else if (
          input["Input Name"] === "email-address" &&
          !this.emailRegex.test(this.formResults[key])
        ) {
          this.errors[
            key
          ] = `Invalid ${input["Option Text"]} (e.g. name@example.com)`;
        } else if (
          input["Input Name"] === "contact-number" &&
          (!this.numRegex.test(this.formResults[key]) ||
            this.formResults[key].length !== 10)
        ) {
          this.errors[
            key
          ] = `Invalid ${input["Option Text"]} (e.g. 0761234765)`;
        } else {
          formData.append(key, this.formResults[key]);
        }
      }

      if (_.isEmpty(this.errors)) {
        this.$http
          .post(
            `${process.env.VUE_APP_BACKEND_URL}contact/create_request`,
            formData
          )
          .then((response) => {
              this.$router.push({ name: "querySent" });
          })
          .catch((error) => {
            if (error.response.data.length > 0) {
              this.contactResponse = error.response.data[0];
            } else {
              this.contactResponse = error.response.data;
            }
          });
      }
      /* eslint-enable */
    },
  },
};
</script>

<style lang="scss">
@import "../styles/variables";
@import "~bulma/sass/utilities/mixins";
@import "../vue-select-corrected";

.is-red {
  color: red;
}

.contact {
  padding: 3rem;
  display: flex;

  .search-container {
    p.control {
      display: none;
    }
  }

  @include until($desktop) {
    flex-direction: column;
  }

  .contact-questions {
    flex: 1;
    flex-basis: 75%;

    .input-group {
      margin-top: 1rem;
    }

    @include from($desktop) {
      margin-right: 3rem;
    }

    .control {
      margin: 0.2rem;
      font-weight: normal;

      .radio {
        display: block;
        margin-left: 0;

        input[type="radio"],
        input[type="checkbox"] {
          display: none;

          &:checked + .radio-checkmark:before {
            content: "C";
            border-color: #01a5e8;
            background-color: #01a5e8;
            color: #fff;
          }
        }

        .radio-checkmark:before {
          content: "U";
          display: inline-block;
          margin-right: 1.5rem;
          border: 1px solid black;
          width: 1.5rem;
          height: 1.5rem;
          text-align: center;
        }
      }

      .text input {
        display: block;
        width: 100%;
        border: none;
        border-radius: 0;
        box-shadow: -3px 5px 8px 1px rgba(120, 120, 120, 0.35);
        z-index: 3 !important;
        height: unset;
        padding: 1rem 2rem;
        background-color: #fff;
        transition: box-shadow 100ms;

        &:focus {
          box-shadow: -3px 5px 8px 1px rgba(80, 80, 80, 0.35);
        }

        &::placeholder {
          color: #2c3e50;
          opacity: 1;
          letter-spacing: 2px;
          font-weight: 500;
        }
      }
    }
  }

  .contact-contact-us {
    flex: 1;
    flex-basis: 50%;

    @include from($desktop) {
      margin-left: 3rem;
    }

    .contact-contact-box {
      .contact-button {
        border-radius: 0;
        padding: 1.25rem 2rem;
        line-height: 0;
      }

      @include from($desktop) {
        background-color: white;
        border-radius: 0;
        -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1);
        box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1);
        color: $secondary-colour;
        display: block;
        padding: 3rem;
      }

      .contact-whatsapp {
        font-weight:normal;
        svg {
          color: #41c351;
        }
      }
    }
  }

  .contact-button {
    border-radius: 0;
    line-height: 0;
    padding: 1.25rem 5rem;
    margin-top: 2rem;
  }
  .opening-hours-wrapper {
    white-space: nowrap;
  }
  @media(max-width: 768px) {
    .opening-hours-wrapper {
      white-space: normal;
    }
  }
}
</style>
